<template>
    <div class="nearActivity" @click="getActivityLink (nearLists.id)">
        <!--進行中-->
        <div :class="nearLists.is_past?'activityItem_end':'activityItem_start'" >
            <div class="activityItem_img">
                <img :src="this.weburl+nearLists.image" alt="">
            </div>
            <div class="activityItem_content">
                <div class="activityItem_left">
                    <span>{{nearLists.is_past?$t('past'):$t('progress')}}</span>
                </div>
                <div class="activityItem_right">
                    <div class="activityItem_title">
                        <h2>{{nearLists.title}}</h2>
                        <p>{{$t('activity_time')+':'+nearLists.start_time +$t('to')+nearLists.end_time}}</p>
                    </div>
                    <p>{{nearLists.brief}}</p>
                </div>
                <div style="clear: both"></div>
            </div>
        </div>
        <!--结束-->
        <!--<div class="activityItem_end" v-else>
            <div class="activityItem_img">
                <img :src="this.weburl+this.nearLists.image" alt="">
            </div>
            <div class="activityItem_content">
                <div class="activityItem_left">
                    <span>已结束</span>
                </div>
                <div class="activityItem_right">
                    <div class="activityItem_title">
                        <h2>{{this.nearLists.title}}</h2>
                        <p>活动时间：{{this.nearLists.start_time}}至{{this.nearLists.end_time}}</p>
                    </div>
                    <p>{{this.nearLists.brief}}</p>
                </div>
                <div style="clear: both"></div>
            </div>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "nearActivity",
        props: ['nearLists'],
        data: function () {
            return {
                isPast: true,
            }
        },
        created: function () {
            // console.log(this.nearLists);
 /*
            if (this.nearLists.is_past == 0) {
                this.isPast = true;
            } else  {
                this.isPast = false;
            }
            console.log(this.isPast);*/
        },
        methods: {
            getActivityLink (id){
                this.$router.push({path: `/activityDetail/${id}`,})
            }

        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }
        }
    }
</script>

<style scoped lang="less"> @import "../../assets/less/common.less";

.nearActivity {
    background: @font-primary;
    margin-bottom: 20px;
}

.activityItem_start,
.activityItem_end,
.nearActivity {
    width: @width;
    .border-radius(10px);
}

.activityItem_start {

    p {
        color: @word;
    }
    .activityItem_left span {
        background: url(../../assets/images/activity/tag_2.png) no-repeat;
        background-size: 50px auto;
    }
}

.activityItem_end {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: #9f9f9e;
    h2, p {
        color: tint(@word, 50%);
    }
    .activityItem_left span {
        background: url(../../assets/images/activity/tag_1.png) no-repeat;
        background-size: 50px auto;
    }
}

.activityItem_content {
    width: @width;
    .box-sizing;
    padding: 0 10px 12px;
}

.activityItem_img {
    width: @width;
    height: 200px;
    .border-radius(10px 10px 0 0);
    img {
        &:extend(.activityItem_img);
    }
}

.activityItem_left {
    float: left;
    width: 16%;
    span {
        height: 45px;
        width: 50px;
        line-height: 40px;
        font-size: .9rem;
        display: block;
        text-align: center;
        color: @font-primary;

    }
}

.activityItem_right {
    float: left;
    margin-left: 6%;
    width: 78%;
    letter-spacing: 1px;
    .activityItem_title {
        padding: 10px 0;
        .border-bottom;
        margin-bottom: 10px;
        h2 {
            font-size: @font + .1;
            margin-bottom: .4rem;
        }
    }
    p {
        color: @word;
        font-size: @font - .2;
        line-height: 15px;
    }
}
    @media (min-width: 768px) and (orientation: portrait){
        .activityItem_start {
            .activityItem_left span {
                background: url(../../assets/images/activity/tag_2.png) no-repeat;
                background-size: 70px auto;
            }
        }

        .activityItem_end {
            .activityItem_left span {
                background: url(../../assets/images/activity/tag_1.png) no-repeat;
                background-size: 70px auto;
            }
        }


        .activityItem_img {
            width: @width;
            height: 343px;
            img {
                &:extend(.activityItem_img);
            }
        }

        .activityItem_left {
            float: left;
            width: 16%;
            span {
                height: 64px;
                width: 70px;
                line-height: 40px;
                font-size:1.2rem;
                display: block;
                text-align: center;
                color: @font-primary;

            }
        }

        .activityItem_right {
            float: left;
            margin-left: 6%;
            width: 78%;
            letter-spacing: 1px;
            .activityItem_title {
                padding: 10px 0;
                h2 {
                    font-size: @font + .3;

                }
            }
            p {
                color: @word;
                font-size: @font ;
                line-height: 15px;
            }
        }
    }
@media (min-width: 1024px) {
    .activityItem_start,
    .activityItem_end
     {
        width: @width;
        .border-radius(10px);
    }
    .nearActivity {
        width: 72%;
        margin:0 auto 40px;
    }
}

</style>
